import { NotificationType } from '@/contexts/auth/AuthContext';

type DecodedJWT = {
  aud: string;
  email: string;
  exp: number;
  iat: number;
  iss: string;
  jti: string;
  name: string;
  nbf: number;
  phone: string;
  sub: string;
  username: string;
  armadores: string;
  permisos: string;
  facwebcc: string;
  cliente_hub_frio: string;
  estado_cuenta_titular: string;
  agente_retencion: string;
  cambioseta: NotificationType;
  armadoresDashboard: string;
  ftpVERMAS?: string;
  ultimo_rut_cliente_liquidacion_electronica_vacio_import?: string;
};

export const decodeJWT = (token: string): DecodedJWT => {
  try {
    const segments = token.split('.');
    if (segments.length !== 3) {
      throw new Error('Invalid JWT: The token must have 3 parts');
    }
    const base64Url = segments[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const payload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => {
          return `%${c.charCodeAt(0).toString(16).padStart(2, '0')}`;
        })
        .join('')
    );

    return JSON.parse(payload);
  } catch (error) {
    throw new Error(`Failed to decode JWT`);
  }
};
